module.exports = __webpack_public_path__ + "img/phimg1.3147942b.png";